import { FormControl, makeStyles } from "@material-ui/core";
import Select from "react-select";
import WindowedSelect from "react-windowed-select";
import { FormSelectSearchFieldProps } from "../../interface/formik/FormSelectSearchFieldProps";

const useStyles = makeStyles({
  control: {
    width: "100%",
  },
});

const customStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  menu: (base: any) => ({ ...base, zIndex: 9999 }),
};

const FormSelectSearchField = ({
  name,
  value,
  options,
  onChange,
  placeholder,
  isClearable = false,
}: FormSelectSearchFieldProps) => {
  const classes = useStyles();

  // Automatically use virtualization if the list is long
  const SelectComponent = options.length > 100 ? WindowedSelect : Select;

  return (
    <FormControl variant="outlined" className={classes.control}>
      <SelectComponent
        name={name}
        id={name}
        className="react-select"
        classNamePrefix="react-select"
        placeholder={placeholder}
        value={value}
        options={options}
        isClearable={isClearable}
        onChange={onChange}
        menuPortalTarget={
          typeof window !== "undefined" ? document.body : undefined
        }
        styles={customStyles}
        isSearchable
        windowThreshold={0}
      />
    </FormControl>
  );
};

export default FormSelectSearchField;
